import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import ThemeToggle from '@/components/ThemeToggle';
import LanguageSwitcher from '@/components/LanguageSwitcher';

const LandingNav = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language?.startsWith('ar');

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-background/80 border-b border-border/50">
      <div className={`max-w-6xl mx-auto flex items-center justify-between px-4 sm:px-6 h-16 ${isRTL ? 'flex-row-reverse' : ''}`}>
        <div className={`flex items-center gap-2 ${isRTL ? 'flex-row-reverse' : ''}`}>
          <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center">
            <CheckCircle className="h-5 w-5 text-primary-foreground" />
          </div>
          <span className="font-bold text-lg">{t('app.name')}</span>
        </div>
        <div className={`flex items-center gap-2 sm:gap-3 ${isRTL ? 'flex-row-reverse' : ''}`}>
          <LanguageSwitcher />
          <ThemeToggle />
          <Button variant="ghost" size="sm" onClick={() => navigate('/auth')} className="hidden sm:inline-flex">
            {t('nav.logIn')}
          </Button>
          <Button size="sm" onClick={() => navigate('/auth')} className="text-xs sm:text-sm rounded-full px-4">
            {t('nav.getStarted')}
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default LandingNav;
